import { createFileRoute } from '@tanstack/react-router'
import { CustomerSuspendedNumbersPage } from '@/features/customer/pages/suspended-numbers'

export const Route = createFileRoute('/_authenticated/customer/suspended-numbers')({
  component: CustomerSuspendedNumbersPage,
})
